<template>
	<Row class="bg-white">
		<Container>
			<article class="post-178 page type-page status-publish entry">
				<header class="entry-header legal-disclosure">
					<h1
						v-if="post && post.title"
						v-html="post && post.title"
						class="entry-title text-[36px] mb-3 text-slate-900"
					></h1>
				</header>

				<div
					class="entry-content legal-disclosure"
					v-html="post.content"
				></div>
			</article>
		</Container>
	</Row>
	<Head>
		<Title>Disclaimer - StocksToTrade</Title>
		<Meta
			name="description"
			content="Last Revised: March 4, 2024 Nothing in this Privacy Statement may be construed to create any obligation for the Company beyond what is required by applicable law. California residents click here to access our California Consumer Protection Act (CCPA) Notice. This Privacy Statement (“Privacy Statement” or “Statement”) describes the practices of StocksToTrade.Com Inc. (“StocksToTrade,” “STT,”…"
		/>
		<Link
			:href="config.current_hostname.slice(0, -1) + '/disclaimer/'"
			rel="canonical"
		/>
		<Meta
			:content="config.current_hostname.slice(0, -1) + '/disclaimer/'"
			property="og:url"
		/>
	</Head>
</template>

<script setup>
const config = useRuntimeConfig().public;
const disclosurePageDataKey = "disclosure-related-partners-page-data";

const { data } = await useAsyncData(disclosurePageDataKey, async () => {
	try {
		const results = await $fetch(
			`${config.hostname}wp-json/wp/v2/pages?slug=disclosure-of-related-and-partner-entities&_embed`
		);
		const page = results?.[0];
		if (page) {
			return {
				post: {
					title: page.title.rendered,
					content: page.content.rendered
				},
				metadata: page.yoast_head_json,
				yoast: page.yoast_head
			};
		}
	} catch (error) {
		console.log({ error });
	}
});

const { post } = data.value;
</script>

<style lang="scss">
@use "../assets/legal-pages" as *;
</style>
